import { StoreState } from '../store.state'


export const getBilling = (state: StoreState) => {
  return state.billing
}
export const getBillingError = (state: StoreState) => {
  return state.billing.error
}
